<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-2">
				<div class="w-full md:w-1/2">
					<div class="w-full mb-5">
						<vs-input 
							label="Product Claim Auto Completed (Days)"
							type="number"
							@keypress="checkValidationNumber"
							v-model="models.productNotif" 
							class="w-full"/>
					</div>
				</div>
			</vs-row>
		
			<vs-row>
				<div class="w-full md:w-1/2">
					<div class="w-full mb-5">
						<vs-input 
							label="Send Notif Birthday Before (Days)"
							type="number"
							@keypress="checkValidationNumber"
							v-model="models.birthdayNotif" 
							class="w-full"/>
					</div>
				</div>
			</vs-row>

			<vs-row>
				<div class="w-full">
					<label v-if="models.contents.length" for="birthday" class="pl-2">Birthday Notif Content</label>
					<div v-for="(content, index) in models.contents" :key="index" class="border border-solid border-grey rounded-lg p-5 mt-1 mb-5 relative">
						<vs-row vs-justify="space-between" vs-w="12">
							<div class="w-full md:w-3/4 lg:w-3/5 flex items-center flex-col md:flex-row">
								<v-select
									v-model="content.tierId"
									placeholder="Search Tier"
									class="w-full md:w-3/5 lg:w-2/3"
									:reduce="tier => tier.id" 
									:options="masters.tiers"
									label="name"
								/>
								<vs-button class="w-full md:w-2/5 lg:w-1/3 ml-0 md:ml-2 mt-3 md:mt-0" color="primary" type="border" icon="upload_file" @click="$refs.file_upload[index].click()">
									<span class="text-xs">Upload Image</span>
								</vs-button>
								<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
									v-on:change="value => AddPhoto(value, index)" hidden />
							</div>
							<vs-button @click="manageContent(index, 'delete')" radius color="danger" type="filled" icon="delete" class="absolute" style="top: -15px; right: -15px"></vs-button>
						</vs-row>

						<a :href="content.image" target="_blank"  v-if="content.image">
							<div class="m-auto mt-5 w-3/5 h-64">
									<img :src="content.image" :alt="content.image" class="w-full h-full object-cover">
							</div>
						</a>

						<vs-row class="mt-4">
							<div class="w-full">
								<vs-textarea v-model="content.content" height="150px"/>
							</div>
						</vs-row>
					</div>
					<vs-button type="filled" color="primary" class="block mt-3 ml-auto" @click="manageContent">Add Content</vs-button>
				</div>
			</vs-row>
			<div class="w-full md:w-1/6 mt-5">
				<vs-button button="submit" color="primary" type="filled" class="w-full">Save</vs-button>
			</div>
			
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import {checkValidationNumber, getUrlOfFile, uploadFile} from '@/utils/helpers'

	export default {
		name: 'FormUser',
		data() {
			return {
				checkValidationNumber,
				getUrlOfFile,
				models: {
					productNotif: "",
					birthdayNotif: "",
					contents: [
						{
							tierId : null,
							image : "",
							content : ""
						}
					]
				},
				masters: {
					tiers: [],
				},
				vars: {
					FormData: new FormData(),
				}
			}
		},
		created() {
			this.getTiers()
			this.getScheduler();
		},
		methods: {
			getScheduler() {
				this.$axios.get(`${api.scheduler}`)
					.then(res => {
						const { data } = res.data;
						this.models.productNotif = data.productNotif
						this.models.birthdayNotif = data.birthdayNotif
						this.models.contents = data.contents
					}).catch(() => this.$router.push({
						name: 'page404'
					}));
			},

			save() {
				this.vars.FormData = new FormData();
				for (const i in this.models) {
					let value = this.models[i]
					if(i === 'contents') {
						value = JSON.stringify(this.models[i])
					}
					this.vars.FormData.append(i, value);
				}
				this.$validator.validate().then(valid => {
					if (valid) {
						this.$axios.put(api.scheduler, this.vars.FormData)
							.then(() => {
								this.getScheduler()
								this.$showToast('Success', `Success update settings`,)
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			},

			getTiers() {
				this.$axios.get(api.mics_tiers)
					.then(res => {
						this.masters.tiers = [...res.data.data]
					})
			},
			async AddPhoto(event, index) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.models.contents[index].image = await uploadFile(event.target.files[0])
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},

			manageContent(idx, action) {
				if(action === 'delete') {
					this.models.contents.splice(idx, 1)
				} else {
					this.models.contents.push(
						{
							tierId : null,
							image : "",
							content : ""
						}
					)
				}
			}
		}
	}
</script>